export interface FitResult {
  cols: number;
  rows: number;
  tileW: number;
  tileH: number;
}

/**
 * Largest 16:9 tile size that fits `n` tiles inside W×H with `gap` between them,
 * with no overflow. Tries every column count and maximizes tile area.
 */
export function bestFitGrid(n: number, W: number, H: number, gap = 0, aspect = 16 / 9): FitResult {
  if (n <= 0 || W <= 0 || H <= 0) return { cols: 0, rows: 0, tileW: 0, tileH: 0 };
  let best = { cols: 1, rows: n, tileW: 0, tileH: 0, area: -1 };
  for (let cols = 1; cols <= n; cols++) {
    const rows = Math.ceil(n / cols);
    const aW = W - (cols - 1) * gap;
    const aH = H - (rows - 1) * gap;
    if (aW <= 0 || aH <= 0) continue;
    const tw = Math.min(aW / cols, (aH / rows) * aspect);
    const th = tw / aspect;
    const area = tw * th;
    if (area > best.area) best = { cols, rows, tileW: tw, tileH: th, area };
  }
  return { cols: best.cols, rows: best.rows, tileW: Math.floor(best.tileW), tileH: Math.floor(best.tileH) };
}
